(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', './ValidationErrors', './ValidationWarnings', '../flowtypes'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('./ValidationErrors'), require('./ValidationWarnings'), require('../flowtypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.ValidationErrors, global.ValidationWarnings, global.flowtypes);
    global.ValidationResponses = mod.exports;
  }
})(this, function (exports, _react, _ValidationErrors, _ValidationWarnings, _flowtypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _ValidationErrors2 = _interopRequireDefault(_ValidationErrors);

  var _ValidationWarnings2 = _interopRequireDefault(_ValidationWarnings);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ValidationResponses = function ValidationResponses(_ref) {
    var _ref$errors = _ref.errors,
        errors = _ref$errors === undefined ? [] : _ref$errors,
        _ref$warnings = _ref.warnings,
        warnings = _ref$warnings === undefined ? [] : _ref$warnings;
    return _react2.default.createElement(
      'div',
      null,
      (!!errors.length || !!warnings.length) && _react2.default.createElement(
        'div',
        { 'data-testId': 'info-fileUploadValidation', className: 'pt-2' },
        !!errors.length && _react2.default.createElement(_ValidationErrors2.default, { errors: errors }),
        !!warnings.length && _react2.default.createElement(_ValidationWarnings2.default, { warnings: warnings })
      )
    );
  };

  exports.default = ValidationResponses;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUploadStatusBox/components/ValidationResponses.js
// module id = 2040
// module chunks = 1